import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgButtonConfirmIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 41,
	height: 36,
	viewBox: "0 0 41 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.6665 21.6248L12.212 32.9998L37.6665 2.6665",
		stroke: "currentColor",
		strokeWidth: 5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgButtonConfirmIcon;
